/* eslint-disable */
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";

function OpenNewTabComponent(props) {
  return /*#__PURE__*/_jsx("svg", {
    width: "1024",
    height: "1024",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M568.167 175l-.001 56.167h-337v561.666h561.667V455.834H849V849H175V175h393.167zM849 175v168h-55.75l-.001-72.452L531.664 532 492 492.192 753.156 231.17l-73.156.028V175h169z",
      fill: "#666",
      fillRule: "nonzero"
    })
  });
}

OpenNewTabComponent.displayName = "OpenNewTabComponent";
export default OpenNewTabComponent;
//# sourceMappingURL=es/OpenNewTabComponent.js.map